import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "31",
  height: "31",
  viewBox: "0 0 31 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.25 12.5346L3 15.6596L15.0528 21.686C15.2168 21.768 15.2988 21.809 15.3848 21.8251C15.4609 21.8394 15.5391 21.8394 15.6152 21.8251C15.7012 21.809 15.7832 21.768 15.9472 21.686L28 15.6596L21.75 12.5346M9.25 18.7846L3 21.9096L15.0528 27.936C15.2168 28.018 15.2988 28.059 15.3848 28.0751C15.4609 28.0894 15.5391 28.0894 15.6152 28.0751C15.7012 28.059 15.7832 28.018 15.9472 27.936L28 21.9096L21.75 18.7846M3 9.40963L15.0528 3.38323C15.2168 3.30125 15.2988 3.26025 15.3848 3.24412C15.4609 3.22983 15.5391 3.22983 15.6152 3.24412C15.7012 3.26025 15.7832 3.30125 15.9472 3.38323L28 9.40963L15.9472 15.436C15.7832 15.518 15.7012 15.559 15.6152 15.5751C15.5391 15.5894 15.4609 15.5894 15.3848 15.5751C15.2988 15.559 15.2168 15.518 15.0528 15.436L3 9.40963Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }